import urlParse from 'url-parse'

export function useGetImageWithSize ({ image, width }: { image?: ImageSize, width: 'small' | 'medium' | 'large' | number }): string {
  if (!image || !image.medium) {
    return ''
  }

  if (typeof width === 'number') {
    const URLInstance = urlParse(image.medium, true)
    URLInstance.set('query', {
      ...URLInstance.query,
      width
    })
    return URLInstance.toString()
  }

  return image[width] || image.medium
}

export default useGetImageWithSize
